export const contactUsApi = {
  sendMessage: (): string => `/api/public/contacts`,
};
